import { Box } from "@mui/material"
import React, { ReactNode, useEffect } from "react"
import { Outlet } from "react-router"
import { CuratedContentSlugV2, s } from "src/utilities/common"

import { Pages } from "../../App"
import { appStore } from "../../store/AppStore"
import { focusStore } from "../../store/FocusStore"
import { dimensions } from "../../utilities/constants"
import { MyStageScreen } from "../MyStage/MyStageScreen"
import { SearchScreen } from "../Search/SearchScreen"
import { SettingsScreen } from "../Settings/SettingsScreen"

import { CuratedScreen } from "./CuratedScreen"

export type TabviewProps = {
  slug: CuratedContentSlugV2
}

export const Tabview = () => {
  const setTabBarSlug = focusStore((state) => state.setTabBarSlug)
  useEffect(() => {
    setTabBarSlug(CuratedContentSlugV2.Discover)
  }, [])

  return (
    <>
      <VisibilityWrapper slug={CuratedContentSlugV2.Discover}>
        <CuratedScreen slug={CuratedContentSlugV2.Discover} />
      </VisibilityWrapper>
      <VisibilityWrapper slug={CuratedContentSlugV2.Audio}>
        <CuratedScreen slug={CuratedContentSlugV2.Audio} />
      </VisibilityWrapper>
      <VisibilityWrapper slug={CuratedContentSlugV2.Live}>
        <CuratedScreen slug={CuratedContentSlugV2.Live} />
      </VisibilityWrapper>
      <VisibilityWrapper slug={Pages.MyStage}>
        <MyStageScreen slug={Pages.MyStage} />
      </VisibilityWrapper>
      <VisibilityWrapper slug={CuratedContentSlugV2.Search}>
        <SearchScreen slug={CuratedContentSlugV2.Search} />
      </VisibilityWrapper>
      <VisibilityWrapper slug={Pages.Settings}>
        <SettingsScreen slug={Pages.Settings} />
      </VisibilityWrapper>
      <Outlet />
    </>
  )
}

const VisibilityWrapper = ({
  slug,
  children,
}: {
  slug?: string
  children: ReactNode
}) => {
  const storeSlug = appStore((state) => state.slug)
  const { width } = dimensions
  return (
    <Box
      sx={{
        transition: "opacity 0.3s linear",
        position: "absolute",
        top: s("184px"),
        left: 0,
        opacity: slug === storeSlug ? 1 : 0,
        // prevent playwright from doing ghost-hovers
        pointerEvents:
          slug === storeSlug && !process.env.REACT_APP_TEST ? "all" : "none",
        minWidth: width,
      }}
    >
      {children}
    </Box>
  )
}
